import React, {
  Component
} from "react";

import {DebounceInput} from 'react-debounce-input';
import PermissionHelper from "../../../helpers/PermissionHelper";


import {
  MDBSpinner,
  MDBTable,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBInput,
  MDBSelect,
  MDBCollapseHeader,
  MDBIcon,
  MDBCollapse,
  MDBPagination,
  MDBPageItem,
  MDBPageNav,
  MDBBtn
} from 'mdbreact';

class CustomerFilter extends Component {

  constructor(props) {
    super(props);

    this.state = {
      customerFilter: null
    }

    this._onCheckboxChange = this._onCheckboxChange.bind(this);
    this._onSelectChange = this._onSelectChange.bind(this);
    this._onInputChange = this._onInputChange.bind(this);
    this._onDirectionChange = this._onDirectionChange.bind(this);
  }

  componentDidMount() {
    //console.log(this.props);
    /*
    var customerFilter = JSON.parse(localStorage.getItem('customerFilter'));
    if(!customerFilter) {
      var customerFilter = this.props.searchComponent.state;
      localStorage.setItem('customerFilter', JSON.stringify(customerFilter));
    }

    this.props.searchComponent.setState(customerFilter);*/
  }

  _onCheckboxChange(e) {
    var name = e.target.name;
    var value = e.target.value;
    var filters = this.props.searchComponent.state.filters;
    filters[name] = value;


    this.props.searchComponent.setState({
        filters: filters,
        page: 0
    }, () => {
        //var customerFilter = this.props.searchComponent.state;
        //localStorage.setItem('customerFilter', JSON.stringify(customerFilter));
        this.props.searchComponent.loadCustomerCollection();
    });

  }

  _onSelectChange(e) {
    var name = e.target.name;
    var value;
    if(e.target.value[0]) {
      value = e.target.value[0];
    } else {
      value = null;
    }
    var filters = this.props.searchComponent.state.filters;
    filters[name] = value;


    this.props.searchComponent.setState({
        filters: filters,
        page: 0
    }, () => {
        //var customerFilter = this.props.searchComponent.state;
        //localStorage.setItem('customerFilter', JSON.stringify(customerFilter));
        this.props.searchComponent.loadCustomerCollection();
    });
  }

  _onDirectionChange(e) {
    var name = e.target.name;
    var value = e.target.value;

    var filters = this.props.searchComponent.state.filters;
    filters[name] = value;

    this.props.searchComponent.setState({
        filters: filters,
        page: 0
    }, () => {
        //var customerFilter = this.props.searchComponent.state;
        //localStorage.setItem('customerFilter', JSON.stringify(customerFilter));
        this.props.searchComponent.loadCustomerCollection();
    });
  }

  _onInputChange(e) {
    var name = e.target.name;
    var value = e.target.value;
    var filters = this.props.searchComponent.state.filters;
    filters[name] = value;


    this.props.searchComponent.setState({
        filters: filters,
        page: 0
    }, () => {
        //var customerFilter = this.props.searchComponent.state;
        //localStorage.setItem('customerFilter', JSON.stringify(customerFilter));
        this.props.searchComponent.loadCustomerCollection();
    });
  }

  render() {
    let component = this;
    return (
      <div className="filter-card">

        <MDBRow>
          <MDBCol md="3" xs="12">
            <MDBSelect
                options={this.props.searchComponent.state.treatmentsFilter}
                selected="Bitte auswählen"
                label="Behandlungen"
                id="field_treatments"
                name="field_treatments"
                getValue={(e) => {
                  this._onSelectChange({
                    target: {
                      name: 'field_treatments',
                      value: e,
                    },
                  });
                }}
            />
          </MDBCol>


          {PermissionHelper._hasPermission('ignore locations') === true &&
            <>
            <MDBCol md="3" xs="12">
              <MDBSelect
                  options={this.props.searchComponent.state.locationsFilter}
                  selected="Bitte auswählen"
                  label="Standort"
                  id="field_location"
                  name="field_location"
                  getValue={(e) => {
                    this._onSelectChange({
                      target: {
                        name: 'field_location',
                        value: e,
                      },
                    });
                  }}
              />
            </MDBCol>
            </>
          }




          <MDBCol md="3" xs="12" className="d-flex col-sort">
            <MDBSelect
                options={this.props.searchComponent.state.sortOptions}
                selected="Sortierung"
                label="Sortierung"
                id="field_sort"
                name="field_sort"
                getValue={(e) => {
                  this._onSelectChange({
                    target: {
                      name: 'field_sort',
                      value: e,
                    },
                  });
                }}
            />

          <MDBBtn flat size="lg" color="primary" onClick={(e) => {
              this._onDirectionChange({
                target: {
                  name: 'field_sort_direction',
                  value: (this.props.searchComponent.state.filters.field_sort_direction == 'asc') ? "desc" : "asc",
                },
              });
          }}>
          {this.props.searchComponent.state.filters.field_sort_direction == 'asc' &&
            <MDBIcon icon="sort-alpha-down-alt" />
          }

          {this.props.searchComponent.state.filters.field_sort_direction == 'desc' &&
            <MDBIcon icon="sort-alpha-up-alt" />
          }

          </MDBBtn>

          </MDBCol>
        </MDBRow>
        <hr />
          <MDBRow>
            <MDBCol>
                <div className="sui-search-box">
                  <div className="sui-search-box__wrapper">
                    <DebounceInput
                      minLength={3}
                      debounceTimeout={800}
                      id="field_searchterm"
                      name="field_searchterm"
                      placeholder="Kundenummer, E-Mail, Name"
                      className="sui-search-box__text-input "
                      onChange={(e) => {
                        this._onInputChange({
                          target: {
                            name: 'field_searchterm',
                            value: e.target.value,
                          },
                        });
                      }}
                      value={this.props.searchComponent.state.filters.field_searchterm}
                    />

                   {!this.props.searchComponent.state.collectionLoaded && (
                     <><MDBSpinner red small /></>
                   )}
                  </div>
                </div>
            </MDBCol>
          </MDBRow>
      </div>
    )
  }

}

export default CustomerFilter;
